import { EvaluationPlanStatus } from '../../enums/evaluation-plan-status.enum';

export const EVALUATION_PLANS_STATUS = {
  [EvaluationPlanStatus.New]: 'NEW',
  [EvaluationPlanStatus.PendingApproval]: 'PENDING',
  [EvaluationPlanStatus.Approved]: 'APPROVED',
  [EvaluationPlanStatus.Denied]: 'DENIED',
};
